import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ContractDetails } from '../models/contract-details';

@Injectable({
  providedIn: 'root'
})
export class ContractDetailsApiService {

  private apiBaseUrl = `${environment.apiUrl}contractDetails`;

  constructor(private httpClient: HttpClient) { }

  public create(contractDetails: ContractDetails): Observable<ContractDetails> {
    return this.httpClient.post<ContractDetails>(`${this.apiBaseUrl}/create`, contractDetails);
  }

  public update(contractDetails: ContractDetails): Observable<ContractDetails> {
    return this.httpClient.patch<ContractDetails>(`${this.apiBaseUrl}/update`, contractDetails);
  }

  public getByOwner(owner: { contractId?: number; extensionId?: number }): Observable<ContractDetails[]> {
    let params = new HttpParams();
    if (owner.contractId != null) {
      params = params.set('contractId', owner.contractId);
    }
    if (owner.extensionId != null) {
      params = params.set('extensionId', owner.extensionId);
    }
    return this.httpClient.get<ContractDetails[]>(`${this.apiBaseUrl}/byOwner`, { params });
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.apiBaseUrl}/delete/${id}`);
  }
}
